import { render, staticRenderFns } from "./Organ.vue?vue&type=template&id=3d357f1c&scoped=true"
import script from "./Organ.vue?vue&type=script&lang=js"
export * from "./Organ.vue?vue&type=script&lang=js"
import style0 from "./Organ.vue?vue&type=style&index=0&id=3d357f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d357f1c",
  null
  
)

export default component.exports